import { defineMessages } from 'react-intl';

export const paginationMessages = defineMessages({
  pagination: {
    id: 'pagination.pagination',
    defaultMessage: 'Pagination',
  },
  previousPage: {
    id: 'pagination.previousPage',
    defaultMessage: 'Previous page',
  },
  nextPage: {
    id: 'pagination.nextPage',
    defaultMessage: 'Next page',
  },
  currentPage: {
    id: 'pagination.currentPage',
    defaultMessage: 'Current page {page}',
  },
  page: {
    id: 'pagination.page',
    defaultMessage: 'Page {page}',
  },
});
